var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfhair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 131 102.3",
    style: {
      enableBackground: "new 0 0 131 102.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "78.5,80.1 78.5,89 61.4,89 61.4,80.1 59.8,80.1 59.8,100.4 61.4,100.4 61.4,90.2 78.5,90.2 78.5,100.4 80.1,100.4  80.1,80.1  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.4,100.4h1.7l-10-20.3h-1.8l-10,20.3H84l2.5-5h13.4L102.4,100.4z M99.3,94H87.1l6.1-12.3L99.3,94z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9,
    y: 80.1,
    width: 1.6,
    height: 20.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.6,92l0.4-0.5c0,0,6.2,0,6.2-5.7c0-5.1-4.7-5.7-4.7-5.7h-15.4H110v20.3h0.1h1.5v-8.8h9.9l7.7,8.8h1.7L123.6,92z  M111.5,90.3v-9h12.7c0,0,4.5-0.2,4.5,4.5c0,4.6-4.7,4.5-4.7,4.5H111.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4,23.8h2.9c0,0,0.5-6.4,7.2-23.5H49.3c0,0-8.7,17.1-9.1,51.8h-7.5c-0.1-29.7-7.8-52-7.8-52h-7.7c10,31.2,9.2,49,9,52 h-4.2V55H26c-0.3,30.4-7,44.9-8.1,47.1h-0.8C7.9,81.1,7.9,49.4,7.9,49.4C7.8,18.7,17.1,0.1,17.1,0.1H9.9 C1.1,18.9,0.6,47.2,0.6,47.2c0.3,16.3,2,30.9,2,30.9H0.1c1.6,9.3,6.7,24,6.7,24h0v0.3h10.9h7c7.5-20.5,8-40.8,7.9-47.4h7.4 c-0.2,7.9-1.3,34.6-8.8,47.4H39c0,0,7.7-17.7,8.1-47.4h11.4V52H47.1C47,49.5,46.8,36.6,49.4,23.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfhair);
export default __webpack_public_path__ + "static/media/ofhair.ed4a43cd6d5c27f0f9eb75699a1ed435.svg";
export { ForwardRef as ReactComponent };